import React from 'react';
import { FaAws } from 'react-icons/fa';
import { SiDocker, SiTerraform, SiGithubactions } from 'react-icons/si';


const Footer = () => {
  return (
    <footer className="text-center py-6 text-gray-400 text-sm">
      &copy; {new Date().getFullYear()} Victor Oluwatobi Akomolafe. All rights reserved.
      <span className="flex justify-center gap-4 mt-4 text-4xl text-softPurple">
        <FaAws title="AWS Certified" />
        <SiDocker title="Docker Expert" />
        <SiTerraform title="Terraform" />
        <SiGithubactions title="CI/CD GitHub" />
      </span>
    </footer>
  );
};

export default Footer;
